import { Button } from "@msuite/ui/button";
import { ChartHeader } from "@msuite/ui/charts";
import { DashboardTile } from "@msuite/ui/dashboard";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useNavigate } from "react-router";
import { incomingInvoiceReviewPath } from "@/components/incoming-invoices";
import { useMyIncomingInvoiceApprovals } from "@/hooks/use-my-incoming-invoice-approvals";
import type { DashboardTileProps } from "../shared";
import { DashboardInvoiceApprovalItem } from "./dashboard-invoice-approval-item";

export function DashboardInvoiceApprovalsItem({ item }: DashboardTileProps) {
	/** Context */
	const { t } = useTranslation();

	/** Hooks */
	const navigate = useNavigate();

	/** Query */
	const { approvals, isLoading, queryKey } = useMyIncomingInvoiceApprovals("pending");

	/** Render */
	return (
		<DashboardTile item={item}>
			<ChartHeader
				title={t("dashboard.invoice_approvals")}
				description={t("dashboard.n_open_invoice_approvals", { count: `${approvals.length}` })}
			/>
			<DashboardTile.List
				isLoading={isLoading}
				data={approvals}
				queryKey={queryKey}
			>
				{approvals.map((approval) => (
					<DashboardTile.List.Item
						key={approval.id}
						onClick={() => navigate(incomingInvoiceReviewPath(approval.incomingInvoiceId))}
						data-cy="dashboard-invoice-approval"
					>
						<DashboardInvoiceApprovalItem approval={approval} />
					</DashboardTile.List.Item>
				))}
			</DashboardTile.List>
			<div className="absolute -right-5 -bottom-3">
				<Button
					size="xs"
					variant="white"
					icon={<Icon name="ArrowRight" />}
					onClick={() => navigate("/controlling/incoming-invoices/approvals")}
					data-cy="dashboard-invoice-approvals-show-all"
				>
					{t("general.show_all")}
				</Button>
			</div>
		</DashboardTile>
	);
}
